import styled, { css } from 'styled-components';
import { themeGet, getBackgroundColor, getMediaQuery } from '@magalu/stereo-ui-styles';
import Flex from '../../atoms/Flex';
import { Text } from '../../atoms';
export const Container = styled.div`
  width: 100%;
  padding: ${props => themeGet('space.2')(props)}px;
  ${({
  desktopMode
}) => !desktopMode && css`
      display: flex;
      justify-content: start;
      overflow-x: scroll;
      scrollbar-width: none;
    `};
`;
export const FilterText = styled(Text)`
  font-size: ${props => themeGet(props.desktopMode ? 'fontSizes.2' : 'fontSizes.0')(props)}px;
  white-space: nowrap;
  color: #8f8f8f;
`;
export const LabelHeader = styled(Flex)`
  padding: ${props => themeGet('space.2')(props)}px;
`;
export const FastFilters = styled(Flex)`
  justify-content: ${props => props.desktopMode ? 'flex-start' : 'center'};
  align-items: center;
`;
export const FilterLink = styled.a`
  text-decoration: none;
  cursor: default;
  justify-content: center;
  display: flex;
`;
export const FastFilterItem = styled.label`
  ${getMediaQuery('small')} {
    min-width: 134px;
  }
  min-width: 90px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  scroll-snap-align: center;
  border: ${themeGet('borders.0')};
  border-radius: ${themeGet('radii.large')};
  align-items: center;
  background: ${props => getBackgroundColor('white')(props)};
  height: ${({
  height
}) => `${height}px`};
  width: fit-content;
  & > img {
    padding: ${themeGet('space.2')}px
      ${props => themeGet(props.desktopMode ? 'space.3' : 'space.2')}px;
    aspect-ratio: 1/1;
    max-width: 100%;
    max-height: 100%;
  }
`;